import React, { Component } from "react";
import { Table } from "reactstrap";
import { v4 as uuid } from "uuid";
import { formatDate } from "../../../Utilities/dateUtils";
import { Button } from "reactstrap";
import { saveAs } from "file-saver";

export class StudentCourseRatings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortedBy: null,
    };
  }

  listSorter = (key, order = "asc") => {
    return (a, b) => {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        return 0;
      }
      const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
      const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA < varB) {
        comparison = 1;
      } else if (varA > varB) {
        comparison = -1;
      }
      this.setState({ sortedBy: key });
      return order === "desc" ? comparison * -1 : comparison;
    };
  };

  render() {
    var commentsResponse = this.props.comments;
    var mappedComments = commentsResponse.map((comment) => {
      return (
        <tr style={{ cursor: "text" }} key={uuid()}>
          <td>{comment.courseName}</td>
          <td>{comment.moduleName}</td>
          <td>{comment.studentSchoolName}</td>
          <td>{comment.grade}</td>
          <td>{comment.comment}</td>
          <td>{formatDate(comment.estimatedDate, "yyyy-MM-dd")}</td>
        </tr>
      );
    });

    var fnExcelReport = function () {
      var tab_text = "<table>";
      commentsResponse.map((comment) => {
        return (tab_text +=
          "<tr>" +
          "<td>" +
          comment.courseName +
          "</td><td>" +
          comment.moduleName +
          "</td><td>" +
          comment.studentSchoolName +
          "</td><td>" +
          comment.grade +
          "</td><td>" +
          comment.comment +
          "</td><td>" +
          comment.studentName +
          "</td><td>" +
          comment.studentEmail +
          "</td><td>" +
          comment.successStatus +
          "</td><td>" +
          comment.score +
          "</td><td>" +
          formatDate(comment.estimatedDate, "yyyy-MM-dd") +
          "</td>" +
          "</tr>");
      });
      tab_text = tab_text + "</table>";
      var data = new Blob(["\ufeff", tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
        encoding: "utf-8",
      });
      saveAs(data, "Betyg1.xls");
    };

    return (
      <div>
        <div className="container-fluid admin-container">
          <Button className="mb-2" onClick={fnExcelReport}>
            Exportera till xls
          </Button>
          <Table
            hover
            className="table table-striped clickable"
            id="grades-table"
          >
            <thead>
              <tr>
                <th
                  onClick={() =>
                    commentsResponse.sort(this.listSorter("courseName", "desc"))
                  }
                >
                  Kurs
                </th>
                <th
                  onClick={() =>
                    commentsResponse.sort(this.listSorter("moduleName", "desc"))
                  }
                >
                  Modul
                </th>
                <th
                  onClick={() =>
                    commentsResponse.sort(
                      this.listSorter("studentSchoolName", "desc")
                    )
                  }
                >
                  Studentens skola
                </th>
                <th
                  onClick={() =>
                    commentsResponse.sort(this.listSorter("grade"))
                  }
                >
                  Betyg
                </th>
                <th
                  onClick={() =>
                    commentsResponse.sort(this.listSorter("comment"))
                  }
                >
                  Kommentar
                </th>
                <th
                  onClick={() =>
                    commentsResponse.sort(this.listSorter("estimatedDate"))
                  }
                  className="text_no-wrap"
                >
                  Ungefärlig tid för betyg
                </th>
              </tr>
            </thead>
            <tbody>{mappedComments}</tbody>
          </Table>
        </div>
      </div>
    );
  }
}
export default StudentCourseRatings;
